module.exports = __webpack_public_path__ + "static/media/database.ae995b63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/project/database.jpg
// module id = 472
// module chunks = 0